import { useTranslation } from "react-i18next";
import CalendarSync from "../../../../components/candidate-calendar/CalendarSync";
import { useAuth } from "../../../../context/AuthContext";
import SettingSection from "../../../../components/personalInfo/SettingSection";

export default function Synchronizers() {
  const LocalBasePath = "page.candidate.dashboard.calendar";
  const { t } = useTranslation("", { keyPrefix: LocalBasePath });
  return (
    <div className="w-full flex flex-col">
      <div>
        <h1 className=" text-lg leading-6 font-medium text-gray-900 my-6">
          {t("calendarSyncs")}
        </h1>
      </div>
      <div className="flex flex-col gap-8">
        <CalendarSync />
        <div className="w-full">
          <SettingSection />
        </div>
      </div>
    </div>
  );
}
